import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=173baffb"
import script from "./GlobalLoader.vue?vue&type=script&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoader.vue?vue&type=style&index=0&id=173baffb&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173baffb')) {
      api.createRecord('173baffb', component.options)
    } else {
      api.reload('173baffb', component.options)
    }
    module.hot.accept("./GlobalLoader.vue?vue&type=template&id=173baffb", function () {
      api.rerender('173baffb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/globals/GlobalLoader.vue"
export default component.exports